<template>
  <div :class="[
      'vform-part-legend',
      'position-relative',
      'w-100',
      'multi-line',
      config.emphasized ? 'vform-emphasized' : ''
    ]">
    <slot name="dropzone"/>
    <div class="w-100"/>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        @editProperty="editProperty"
        @removeBlock="$emit('removeBlock')"
    />
    <div v-if="editable && !legend">
      <h3>{{ $t('vform.legendPlaceholder') }}</h3>
    </div>
    <div v-else-if="legend">
      <div v-if="loadingLegend">
        Loading...
      </div>
      <div v-else-if="!Object.values(legend).length">
        {{ $t('vform.noCaptionsDetected') }}
      </div>
      <part-info-display
          v-for="(item, index) in legend"
          class="mb-2"
          :key="index"
          :background-color="config.backgroundColor ? config.backgroundColor : ''"
          :border-color="config.borderColor ? config.borderColor : (fontColor ? fontColor : (contrastColor ? contrastColor : ''))"
          :font-color="config.fontColor ? config.fontColor : fontColor"
          :item-letter="item.letter"
          :item-name="item.name"
          :meta-fields="config.metaFields"
          :meta-values="$store.getters.getInstanceSquashedMetaValById(item.instanceId)"
          :title-alignment="config.titleAlignment ? config.titleAlignment : 'left'"
          :text-alignment="config.textAlignment ? config.textAlignment : 'left'"
      />
    </div>
    <div v-else>
      {{ $t('vform.partLegendLoading') }}
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import ToWordMixinJs from "@/components/vForm/mixins/toWordMixin.js.vue";
import MetaSetsMixin from "@/components/mixins/MetaSetsMixin.js";
import PartBlockMixin from "@/components/vForm/mixins/PartBlockMixin.js.vue";
import ColorContrastMixin from "@/components/mixins/ColorContrastMixin.js";
import EditorOverlay from "./EditorOverlay";
import PartInfoDisplay from "@/components/vForm/PartInfoDisplay.vue";

export default {
  name: "PARTLEGEND",
  components: {
    EditorOverlay,
    PartInfoDisplay
  },
  mixins: [ToWordMixinJs, ElementMixin, MetaSetsMixin, ColorContrastMixin, PartBlockMixin],
  props: {
    /**
     * The slides array coming from the config.json of a vSTAGE package
     * */
    slides: {type: Array, default: null},
    state: {type: Object, required: true},
  },
  data() {
    return {
      localString: "",
      legend: null,
      lastKnownSlide: "",
      loadingLegend: false,
    };
  },
  watch: {
    state: {
      deep: true,
      handler(val) {
        if (val.activeSlideUuid !== this.lastKnownSlide) {
          this.lastKnownSlide = val.activeSlideUuid;
          this.setLegend();
        }
      }
    },
    'config.metaFields': {
      handler() {
        this.setLegend();
      }
    }
  },
  beforeMount() {
    this.setUniqueId();
    this.setLocalString();
  },
  mounted() {
    this.increaseCounter();
    this.setLegend();
  },
  methods: {
    /**
     * Generates the legend for the slides
     * @param projectConfig
     * @param slideUuids
     * @returns {Promise<[]>}
     */
    async setLegend() {
      this.loadingLegend = true;
      try {
        this.legend = [];
        const legendSlides = await this.generateLegendForSlides(this.state.projectConfig, [this.state.activeSlideUuid])
        this.$set(this, 'legend', legendSlides);
      } catch (e) {
        this.$set(this, 'legend', []);
      }
      this.loadingLegend = false;
    },
    setLocalString() {
      this.localString = this.getLabel(this.config, this.lang);
    },
    onInput(e) {
      this.setLabel(this.config, this.lang, e.target.innerText);
    },
    save() {
      this.editing = false;
    },
    setEditing() {
      if (this.editable) {
        this.editing = true;
        this.setCursor(this.uniqueId);
      }
    },
    validate() {
      return true;
    },
    checkRequired() {
      return true;
    },
    getData() {
      return null;
    }
  }
}
</script>
